import {
  getOrders,
  getOrder,
  updateOrderStatus,
  getOrdersToCsv,
  getOrdersFiltered
} from '../services/napi';
import {
  ORDERS_FETCH_SUCCESS,
  GET_ORDER_SUCCESS,
  ORDER_LOADING,
  SET_ORDER_STATUS_DRAFT,
  DOWNLOAD_ORDERS_SUCCESS
} from '../constant/actionType';

export function fetchAllOrders() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await getOrders(projectId);
      dispatch({
        data: response.data.data,
        type: ORDERS_FETCH_SUCCESS
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function fetchAllOrdersFiltered(body) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await getOrdersFiltered(projectId, body);
      dispatch({
        data: response.data.orders,
        type: ORDERS_FETCH_SUCCESS
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function downloadFileAction() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await getOrdersToCsv(projectId);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `orders.csv`);
    document.body.appendChild(link);
    link.click();

    dispatch({
      data: response.data,
      type: DOWNLOAD_ORDERS_SUCCESS
    });
  };
}

export function fetchOrderAction(orderId) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await getOrder(projectId, orderId);
    dispatch({ data: response.data.order, type: GET_ORDER_SUCCESS });
  };
}

export function setOrderStatusDraft(body) {
  return async (dispatch) => {
    try {
      dispatch({
        data: body,
        type: SET_ORDER_STATUS_DRAFT
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function updateOrderAction(orderId, body, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    await updateOrderStatus(projectId, orderId, body);
    if (onSuccess) {
      onSuccess();
    }
  };
}

export function cleanupAction() {
  return (dispatch) => {
    dispatch({
      type: ORDER_LOADING
    });
  };
}
